import { ICompany } from '../company/_models';

export function isITerm(term: ITerm | IAppTermDocument): term is ITerm {
	return (term as ITerm)?.locale !== undefined;
}

export enum TermType {
	app = 'app',
	cluster = 'cluster'
}

export interface ITerm {
	active: boolean;
	id: string;
	locale: string;
	name: string;
	version: string;
	filename?: string;
	entityId?: string;
	entityType?: string;
}

export interface IModifiedBy {
	ts: number;
	email: string;
	firstName: string;
	lastName: string;
	uid: string;
}

export interface ISortedTerm {
	id: string;
	name: string;
	entityId?: string;
	entityType?: string;
	version: string;
	active: boolean;
	highestActiveVersion: string;
	highestDraftVersion: string;
	versionHistory: string[];
	versions: {
		[version: string]: {
			[locale: string]: ITerm;
		};
	};
}

export function isISortedTerm(term: ISortedTerm | ISortedAppTerm): term is ISortedTerm {
	return (term as ISortedTerm)?.id !== undefined;
}

export interface ISortedAppTerm {
	companyId: string;
	termsId: string;
	entityType: string;
	displayName: string;
	displayNames?: {
		[locale: string]: string
	};
	activeVersion: number;
	latestVersion: number;
	alias?: string;
	hasDraft?: boolean;
	documents: {
		[version: number]: IAppTerm;
	};
}

export function isIAppTerm(term: IAppTerm | ITerm): term is IAppTerm {
	return (term as IAppTerm)?.displayVersion !== undefined;
}

export interface IAppTerm {
	version: number;
	filename?: string;
	displayVersion: string;
	url?: string;
	status: string; // archived | active | draft
	createdBy?: IModifiedBy;
	publishedBy?: IModifiedBy;
	active?: boolean;
}

export interface IRequiredAppTerm {
	companyId: string;
	alias?: string;
	termsId: string;
	displayName: string;
	displayNames?: {
		[locale: string]: string
	};
	filename?: string;
	url?: string;
	version: number;
	displayVersion: string;
	entityType: string;
	active: boolean;
	status: string; // archived | active | draft
}

export interface IAppTermShallowDocument {
	companyId: string;
	termsId: string;
	entityType: string;
	displayName: string;
	activeVersion: number;
	latestVersion: number;
	alias?: string;
}

export interface IAppTermDocument {
	companyId: string;
	termsId: string;
	entityType: string;
	displayName: string;
	alias?: string;
	active: boolean;
	version: number;
	displayVersion: string;
	status: string;
	url?: string;
	filename?: string;
	createdBy?: IModifiedBy;
	publishedBy?: IModifiedBy;
}

export interface ILegalUploader {
	id?: string;
	name: string;
	alias?: string;
	url?: string;
	locale?: string;
	active: boolean;
	version?: string;
	filename?: string;
	displayVersion?: string;
	file?: any;
}

export enum TermState {
	live = 'live',
	draft = 'draft',
	archived = 'archived',
	signed = 'signed',
	unsigned = 'unsigned'
}

export interface ITermsPayload {
	accepted: boolean;
	terms: ITerm;
}

export interface ILegalsServiceData {
	app?: ISortedAppTerm[];
	appKey?: {
		[clientId: string]: IAppRequiredTerms;
	};
}

export enum DisplayableContentType {
	pdf = 'application/pdf',
	html = 'text/html',
	text = 'text/plain'
}

export interface ITermResponse {
	[TermType.app]?: ISortedAppTerm;
	[TermType.cluster]?: ICompany;
}

export interface IAppRequiredTerms {
	cluster?: ISortedAppTerm[];
	oAuthApp: ISortedAppTerm[];
}
